// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import TradesWorkTitleTable from './twt-table';
// assets
//

// ----------------------------------------------------------------------

export default function TechnicalTradesWorkTitle() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <TradesWorkTitleTable />
        </Container >
    );
}
